export enum MatchFilter {
  Cancelled = 'cancelled',
  Live = 'live',
}
